// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const startHorsesGameService = async ({currency, gameType}: {currency: string; gameType: string}) => {
  return privateRequest.post(
    `${ConfEnv.BASE_URL}/elinmejorable/horses/start-game?currency=${encodeURIComponent(currency)}&game_type=${encodeURIComponent(gameType)}`
  );
};
